import React, { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";
import { fetchWithAuth } from "../config/api";
import BookingManager from "./BookingManager";
import StaffPerformance from "./StaffPerformance";
import BillingForm from "./BillingForm";
import BulkMessenger from "./BulkMessenger";
import IssuedBills from "./IssuedBills";
import Reports from "./Reports";
import ItemManager from "./ItemManager";
import ControlCenter from "./ControlCenter";

export default function ManagerDashboard() {
  const { logout } = useAuth();
  const [tab, setTab] = useState("billing");
  const [billingTab, setBillingTab] = useState("new");
  const [canSendBulk, setCanSendBulk] = useState(false);
  const [canManageItems, setCanManageItems] = useState(false);

  useEffect(() => {
    const loadPerms = async () => {
      try {
        const res = await fetchWithAuth("/api/user/permissions/");
        if (res.ok) {
          const j = await res.json();
          setCanSendBulk(Boolean(j && j.can_send_bulk));
          setCanManageItems(Boolean(j && (j.is_superuser || ["admin", "manager"].includes(j.role))));
        } else if (res.status === 401 || res.status === 403) {
          logout();
        } else {
          console.error("Permissions failed with status", res.status);
        }
      } catch (err) {
        console.error("perm check error:", err);
        // don’t force logout on transient network errors
      }
    };
    loadPerms();
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const tabStyle = (key) =>
    tab === key ? { outline: "2px solid #333", outlineOffset: 2 } : { opacity: 0.85 };
  const subTabStyle = (key) =>
    billingTab === key ? { outline: "2px solid #333", outlineOffset: 2 } : { opacity: 0.85 };

  return (
    <div style={{ minHeight: "100vh", padding: "2rem" }}>
      <div className="card" style={{ maxWidth: 1000, margin: "0 auto" }}>
        {/* Header + logout */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
            gap: 8,
          }}
        >
          <h2 style={{ margin: 0 }}>Manager Dashboard</h2>
          <button className="btn" type="button" onClick={logout}>
            Log out
          </button>
        </div>

        <div
          style={{
            display: "flex",
            gap: 8,
            marginBottom: 16,
            flexWrap: "wrap",
          }}
        >
          <button className="btn" style={tabStyle("billing")} onClick={() => setTab("billing")}>
            Billing
          </button>
          <button className="btn" style={tabStyle("reports")} onClick={() => setTab("reports")}>
            Reports
          </button>
          {canManageItems && (
            <button className="btn" style={tabStyle("items")} onClick={() => setTab("items")}>
              Retail Items
            </button>
          )}
          <button className="btn" style={tabStyle("bookings")} onClick={() => setTab("bookings")}>
            Bookings
          </button>
          <button className="btn" style={tabStyle("performance")} onClick={() => setTab("performance")}>
            Staff Performance
          </button>
          {canSendBulk && (
            <button className="btn" style={tabStyle("bulk")} onClick={() => setTab("bulk")}>
              Bulk Messaging
            </button>
          )}
          <button className="btn" style={tabStyle("settings")} onClick={() => setTab("settings")}>
            Settings
          </button>
        </div>

        {tab === "billing" && (
          <div>
            {/* New Bill and Issued Bills are two halves of the same job, so
                they live together. Billing opens on New Bill, keeping the
                day-to-day path exactly as many clicks as before. */}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
              <button
                className="btn"
                type="button"
                style={subTabStyle("new")}
                onClick={() => setBillingTab("new")}
              >
                New Bill
              </button>
              <button
                className="btn"
                type="button"
                style={subTabStyle("issued")}
                onClick={() => setBillingTab("issued")}
              >
                Issued Bills
              </button>
            </div>

            {billingTab === "new" ? <BillingForm /> : <IssuedBills />}
          </div>
        )}
        {tab === "reports" && <Reports />}
        {tab === "items" && canManageItems && <ItemManager />}
				{tab === "bookings" && <BookingManager />}
        {tab === "performance" && <StaffPerformance />}
        {tab === "bulk" && canSendBulk && <BulkMessenger />}
        {tab === "settings" && <ControlCenter />}
        {tab === "bulk" && !canSendBulk && (
          <div className="card">
            You don&apos;t have permission to use Bulk Messaging.
          </div>
        )}
      </div>
    </div>
  );
}
